import {
  Component,
  OnInit,
  OnDestroy,
  OnChanges,
  SimpleChanges,
  Inject,
  PLATFORM_ID,
  Input,
} from "@angular/core";
import { CommonModule, isPlatformBrowser } from "@angular/common";
import { HugeiconsIconComponent } from "@hugeicons/angular";
import { Pdf01Icon, Loading03Icon } from "@hugeicons/core-free-icons";

interface Slide {
  id: string;
  headline: string;
  subhead: string;
  visual: "matcher" | "alerts" | "analyser";
}

const SLIDES: Slide[] = [
  {
    id: "matcher",
    headline: "Get matched to roles that fit you",
    subhead:
      "A clear fit signal so you spend time on roles that actually suit you.",
    visual: "matcher",
  },
  {
    id: "alerts",
    headline: "Never miss a role worth applying to",
    subhead: "Daily alerts for jobs that match your criteria",
    visual: "alerts",
  },
  {
    id: "analyser",
    headline: "Pass the ATS before you hit send",
    subhead: "Instant feedback on your resume strength",
    visual: "analyser",
  },
];

@Component({
  selector: "app-login-carousel",
  standalone: true,
  imports: [CommonModule, HugeiconsIconComponent],
  templateUrl: "./login-carousel.component.html",
  styleUrls: ["./login-carousel.component.scss"],
  host: {
    class: "block h-full w-full",
  },
})
export class LoginCarouselComponent
  implements OnInit, OnDestroy, OnChanges
{
  /** When the login modal opens, carousel resets to slide 1. */
  @Input() isOpen = false;

  /** Same icons as homepage resume toolkit card. */
  readonly icons = { pdf: Pdf01Icon, loading: Loading03Icon };

  slides = SLIDES;
  currentIndex = 0;
  private autoAdvanceInterval: any;
  private readonly AUTO_ADVANCE_MS = 4500;
  isPaused = false;

  constructor(@Inject(PLATFORM_ID) private platformId: object) {}

  ngOnChanges(changes: SimpleChanges): void {
    const open = changes["isOpen"];
    if (!open) {
      return;
    }
    if (open.currentValue === true && open.previousValue !== true) {
      this.currentIndex = 0;
    }
  }

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.startAutoAdvance();
    }
  }

  ngOnDestroy(): void {
    this.stopAutoAdvance();
  }

  private startAutoAdvance(): void {
    this.autoAdvanceInterval = setInterval(() => {
      if (!this.isPaused) {
        this.next();
      }
    }, this.AUTO_ADVANCE_MS);
  }

  private stopAutoAdvance(): void {
    if (this.autoAdvanceInterval) {
      clearInterval(this.autoAdvanceInterval);
    }
  }

  next(): void {
    this.currentIndex = (this.currentIndex + 1) % this.slides.length;
  }

  previous(): void {
    const len = this.slides.length;
    this.currentIndex = (this.currentIndex - 1 + len) % len;
  }

  goToSlide(index: number): void {
    this.currentIndex = index;
  }

  onMouseEnter(): void {
    this.isPaused = true;
  }

  onMouseLeave(): void {
    this.isPaused = false;
  }
}
